import { render, staticRenderFns } from "./studentSideMenu.vue?vue&type=template&id=2e2b078d&scoped=true"
import script from "./studentSideMenu.vue?vue&type=script&lang=js"
export * from "./studentSideMenu.vue?vue&type=script&lang=js"
import style0 from "./studentSideMenu.vue?vue&type=style&index=0&id=2e2b078d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2b078d",
  null
  
)

export default component.exports